(function () {
  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function setBodyLocked(isLocked) {
    document.body.style.overflow = isLocked ? "hidden" : "";
    document.body.classList.toggle("cart-drawer-open", isLocked);
  }

  function initMenu() {
    var drawer = qs("[data-menu-drawer]");
    var toggle = qs("[data-menu-toggle]");
    if (!drawer || !toggle) return;

    function openMenu() {
      drawer.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      setBodyLocked(true);
    }

    function closeMenu() {
      drawer.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      setBodyLocked(false);
    }

    toggle.addEventListener("click", function () {
      if (drawer.classList.contains("is-open")) closeMenu();
      else openMenu();
    });

    qsa("[data-menu-close]").forEach(function (button) {
      button.addEventListener("click", closeMenu);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeMenu();
    });
  }

  function initBeforeAfter() {
    qsa("[data-ba-slider]").forEach(function (slider) {
      var range = qs("[data-ba-range]", slider);
      if (!range) return;

      function update() {
        var position = Number(range.value);
        slider.style.setProperty("--ba-position", position + "%");
        slider.classList.toggle("is-before-label-hidden", position < 18);
        slider.classList.toggle("is-after-label-hidden", position > 82);
      }

      range.addEventListener("input", update);
      range.addEventListener("change", update);
      update();
    });
  }

  function initHeroSlideshow() {
    qsa("[data-hero-slideshow]").forEach(function (slideshow) {
      var slides = qsa("[data-hero-slide]", slideshow);
      if (slides.length < 2) return;

      var activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains("is-active");
      });
      if (activeIndex < 0) activeIndex = 0;

      function setActiveSlide(nextIndex) {
        slides.forEach(function (slide, index) {
          var isActive = index === nextIndex;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");

          qsa("a, button", slide).forEach(function (control) {
            if (isActive) control.removeAttribute("tabindex");
            else control.setAttribute("tabindex", "-1");
          });
        });

        activeIndex = nextIndex;
      }

      setActiveSlide(activeIndex);

      window.setInterval(function () {
        setActiveSlide((activeIndex + 1) % slides.length);
      }, 5200);
    });
  }

  function formatCartCount(count) {
    qsa("[data-cart-count]").forEach(function (node) {
      node.textContent = count;
    });
  }

  function openCart() {
    var drawer = qs("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.removeAttribute("aria-hidden");
    setBodyLocked(true);
  }

  function closeCart() {
    var drawer = qs("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    setBodyLocked(false);
  }

  function refreshCartDrawer() {
    if (!window.themeRoutes) return Promise.resolve();

    return fetch(window.themeRoutes.cartUrl + "?section_id=cart-drawer", {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var next = qs("[data-cart-drawer-content]", doc);
        var current = qs("[data-cart-drawer-content]");
        if (next && current) current.innerHTML = next.innerHTML;
        initCartLineButtons();
      })
      .catch(function () {});
  }

  function refreshCartCount() {
    if (!window.themeRoutes) return Promise.resolve();

    return fetch(window.themeRoutes.cartJson)
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        formatCartCount(cart.item_count || 0);
      })
      .catch(function () {});
  }

  function initCartOpenClose() {
    qsa("[data-cart-open]").forEach(function (button) {
      button.addEventListener("click", openCart);
    });

    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-cart-close]")) {
        closeCart();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeCart();
    });
  }

  function changeCartLine(key, quantity) {
    if (!window.themeRoutes) return;

    fetch(window.themeRoutes.cartChange + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(refreshCartCount)
      .then(refreshCartDrawer);
  }

  function initCartLineButtons() {
    qsa("[data-cart-line]").forEach(function (line) {
      var key = line.getAttribute("data-line-key");
      var quantityNode = qs("[data-cart-line-quantity]", line);
      var quantity = Number(quantityNode ? quantityNode.textContent : 1);
      var minus = qs("[data-cart-qty-minus]", line);
      var plus = qs("[data-cart-qty-plus]", line);
      var remove = qs("[data-cart-remove]", line);

      if (minus) minus.addEventListener("click", function () { changeCartLine(key, Math.max(0, quantity - 1)); });
      if (plus) plus.addEventListener("click", function () { changeCartLine(key, quantity + 1); });
      if (remove) remove.addEventListener("click", function () { changeCartLine(key, 0); });
    });
  }

  function initProductForm() {
    qsa("[data-product-form]").forEach(function (form) {
      var variantInput = qs("[data-variant-input]", form);
      var addButton = qs("[data-add-button]", form);
      var price = qs("[data-product-price]");
      var availability = qs("[data-product-availability]");
      var mainImage = qs("[data-main-product-image]");
      var quantityInput = qs("[data-quantity-input]", form);
      var variantsScript = qs("[data-product-variants-json]", form);
      var variants = [];

      if (variantsScript) {
        try {
          variants = JSON.parse(variantsScript.textContent || "[]");
        } catch (error) {
          variants = [];
        }
      }

      function getSelectedOptions() {
        return qsa("[data-product-option-group]", form)
          .sort(function (a, b) {
            return Number(a.getAttribute("data-option-position") || 0) - Number(b.getAttribute("data-option-position") || 0);
          })
          .map(function (group) {
            var active = qs("[data-product-option-button].is-active", group);
            return active ? active.getAttribute("data-option-value") : "";
          });
      }

      function findSelectedVariant() {
        var selectedOptions = getSelectedOptions();
        return variants.find(function (variant) {
          if (!variant.options || variant.options.length !== selectedOptions.length) return false;
          return variant.options.every(function (value, index) {
            return value === selectedOptions[index];
          });
        });
      }

      function updateVariant(variant) {
        var available = Boolean(variant && variant.available);

        if (variantInput && variant) variantInput.value = variant.id;
        if (price && variant) price.textContent = variant.price;
        if (availability) availability.textContent = available ? "" : "Currently unavailable";
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? "Add to cart" : "Sold out";
        }
        if (variant && variant.image && mainImage) mainImage.setAttribute("src", variant.image);
      }

      qsa("[data-product-option-button]", form).forEach(function (button) {
        button.addEventListener("click", function () {
          var group = button.closest("[data-product-option-group]");
          if (!group) return;

          qsa("[data-product-option-button]", group).forEach(function (item) {
            item.classList.remove("is-active");
            item.setAttribute("aria-pressed", "false");
          });

          button.classList.add("is-active");
          button.setAttribute("aria-pressed", "true");

          var current = qs("[data-selected-option-value]", group);
          if (current) current.textContent = button.getAttribute("data-option-value") || "";

          updateVariant(findSelectedVariant());
        });
      });

      qsa("[data-variant-button]", form).forEach(function (button) {
        button.addEventListener("click", function () {
          qsa("[data-variant-button]", form).forEach(function (item) {
            item.classList.remove("is-active");
          });
          button.classList.add("is-active");
          variantInput.value = button.getAttribute("data-variant-id");

          var priceText = button.getAttribute("data-variant-price");
          var available = button.getAttribute("data-variant-available") === "true";
          if (price) price.textContent = priceText;
          if (availability) availability.textContent = available ? "In stock" : "Currently unavailable";
          if (addButton) {
            addButton.disabled = !available;
            addButton.textContent = available ? "Add to cart" : "Sold out";
          }

          var image = button.getAttribute("data-variant-image");
          if (image && mainImage) mainImage.setAttribute("src", image);
        });
      });

      qsa("[data-product-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (!mainImage) return;
          mainImage.setAttribute("src", thumb.getAttribute("data-image-src"));
          mainImage.setAttribute("alt", thumb.getAttribute("data-image-alt") || "");
        });
      });

      var minus = qs("[data-qty-minus]", form);
      var plus = qs("[data-qty-plus]", form);
      if (minus && quantityInput) {
        minus.addEventListener("click", function () {
          quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
        });
      }
      if (plus && quantityInput) {
        plus.addEventListener("click", function () {
          quantityInput.value = Number(quantityInput.value || 1) + 1;
        });
      }

      form.addEventListener("submit", function (event) {
        if (!window.themeRoutes) return;
        event.preventDefault();

        var formData = new FormData(form);
        fetch(window.themeRoutes.cartAdd + ".js", {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to add this product.");
            return response.json();
          })
          .then(refreshCartCount)
          .then(refreshCartDrawer)
          .then(openCart)
          .catch(function () {
            form.submit();
          });
      });
    });
  }

  function getQuickLookVariants(form) {
    var script = qs("[data-quick-look-variants]", form);
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function getQuickLookSelectedOptions(form) {
    return qsa("[data-quick-option-group]", form).map(function (group) {
      var active = qs("[data-quick-option-button].is-active", group);
      return active ? active.getAttribute("data-option-value") : "";
    });
  }

  function findQuickLookVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      if (!variant.options || variant.options.length !== selectedOptions.length) return false;
      return variant.options.every(function (value, index) {
        return value === selectedOptions[index];
      });
    });
  }

  function updateQuickLookVariant(form) {
    var modal = form.closest("[data-quick-look-modal]");
    var variants = getQuickLookVariants(form);
    var selectedOptions = getQuickLookSelectedOptions(form);
    var variant = selectedOptions.length ? findQuickLookVariant(variants, selectedOptions) : variants[0];
    if (!variant) return;

    var variantInput = qs("[data-quick-look-variant-input]", form);
    var price = modal ? qs("[data-quick-look-price]", modal) : null;
    var addButton = qs("[data-quick-look-add]", form);
    var image = modal ? qs("[data-quick-look-image]", modal) : null;

    if (variantInput) variantInput.value = variant.id;
    if (price) price.textContent = variant.price;
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? "Add To Cart" : "Sold out";
    }
    if (image && variant.image) image.setAttribute("src", variant.image);
  }

  function openQuickLook(modal) {
    if (!modal) return;
    modal.classList.add("is-open");
    modal.removeAttribute("aria-hidden");
    modal.scrollTop = 0;
    setBodyLocked(true);

    var closeButton = qs("[data-quick-look-close]", modal);
    if (closeButton) closeButton.focus();
  }

  function closeQuickLook(modal) {
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    setBodyLocked(false);
  }

  function initQuickLook() {
    qsa("[data-quick-look-modal]").forEach(function (modal) {
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });

    qsa("[data-quick-look-open]").forEach(function (button) {
      button.addEventListener("click", function () {
        var modalId = button.getAttribute("aria-controls");
        var modal = modalId ? document.getElementById(modalId) : null;
        openQuickLook(modal);
      });
    });

    document.addEventListener("click", function (event) {
      var closeButton = event.target.closest("[data-quick-look-close]");
      if (!closeButton) return;

      var modal = closeButton.closest("[data-quick-look-modal]");
      closeQuickLook(modal);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;

      qsa("[data-quick-look-modal].is-open").forEach(function (modal) {
        closeQuickLook(modal);
      });
    });

    qsa("[data-quick-look-form]").forEach(function (form) {
      qsa("[data-quick-option-button]", form).forEach(function (button) {
        button.addEventListener("click", function () {
          var group = button.closest("[data-quick-option-group]");
          if (!group) return;

          qsa("[data-quick-option-button]", group).forEach(function (item) {
            item.classList.remove("is-active");
          });
          button.classList.add("is-active");

          var current = qs("[data-quick-option-current]", group);
          if (current) current.textContent = button.getAttribute("data-option-value") || "";

          updateQuickLookVariant(form);
        });
      });

      var quantityInput = qs("[data-quick-quantity-input]", form);
      var minus = qs("[data-quick-qty-minus]", form);
      var plus = qs("[data-quick-qty-plus]", form);
      if (minus && quantityInput) {
        minus.addEventListener("click", function () {
          quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
        });
      }
      if (plus && quantityInput) {
        plus.addEventListener("click", function () {
          quantityInput.value = Number(quantityInput.value || 1) + 1;
        });
      }

      form.addEventListener("submit", function (event) {
        if (!window.themeRoutes) return;
        event.preventDefault();

        var modal = form.closest("[data-quick-look-modal]");
        var formData = new FormData(form);
        fetch(window.themeRoutes.cartAdd + ".js", {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to add this product.");
            return response.json();
          })
          .then(refreshCartCount)
          .then(refreshCartDrawer)
          .then(function () {
            closeQuickLook(modal);
            openCart();
          })
          .catch(function () {
            form.submit();
          });
      });

      updateQuickLookVariant(form);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMenu();
    initHeroSlideshow();
    initBeforeAfter();
    initCartOpenClose();
    initCartLineButtons();
    initProductForm();
    initQuickLook();
  });
})();
